<template>
  <VPanel class="p-6">
    <h1 class="text-lg">
      مدیریت دسته بندی
      <span>{{ $helper.renderCategoryType(this.$route.params.type) }}</span>
    </h1>
    <hr class="border-dark-line mt-6">

    <div class="grid grid-cols-4 mt-6 gap-10">
      <a href="#" @click.prevent="modalCreate = true"
         class="flex flex-col justify-center items-center border-2 border-accent border-dashed rounded-xl min-h-[20rem]">
        <PlusIcon/>
        <span class="text-accent">دسته بندی جدید</span>
      </a>

      <CategoryCard
          v-for="(category, index) in categories"
          :key="category.id"
          :category="category"
          @edited="categoryEdited($event, index)"/>

    </div>

    <ModalCategory
        :show="modalCreate"
        @click="modalCreate = !modalCreate"
        @created="categoryCreated"/>

  </VPanel>
</template>

<script>
import VPanel from "@/components/VPanel";
import PlusIcon from "@/components/Icons/PlusIcon";
import CategoryCard from "@/components/Setting/CategoryCard";
import {getCategories} from "@/API/API";
import ModalCategory from "@/components/Modal/ModalCategory";

export default {
  name: "ProductView",
  components: {ModalCategory, CategoryCard, PlusIcon, VPanel},
  data() {
    return {
      categories: [],
      modalCreate: false,
    }
  },
  async created() {
    this.categories = (await getCategories(this.$route.params.type)).data
  },
  methods: {
    categoryCreated(category) {
      this.modalCreate = false
      this.categories.unshift(category)
    },
    categoryEdited(category, index) {
      this.categories[index] = category
    }
  }
}
</script>

<style scoped>

</style>